import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Fix for deprecated StorageType.persistent
if (typeof window !== 'undefined') {
  try {
    // Track if we've already requested persistence to avoid multiple requests
    let persistenceRequested = false;
    let persistenceValue: boolean | null = null;

    // Define interface for the window with StorageType
    interface WindowWithStorage extends Window {
      StorageType?: {
        persistent?: number;
      };
    }
    
    // Cast window to our extended interface
    const win = window as WindowWithStorage;
    
    // Initialize StorageType if it doesn't exist
    win.StorageType = win.StorageType || {};
    
    // Redirect any attempt to access StorageType.persistent to use navigator.storage instead
    Object.defineProperty(win.StorageType, 'persistent', {
      get: function() {
        console.warn('StorageType.persistent is deprecated. Please use standardized navigator.storage instead.');
        
        // Only request persistence once
        if (!persistenceRequested && navigator.storage && typeof navigator.storage.persist === 'function') {
          persistenceRequested = true;
          
          // Check if we already have persistence
          navigator.storage.persisted().then(isPersisted => {
            if (isPersisted) {
              console.info('Storage persistence already granted.');
              persistenceValue = true;
            } else {
              // Request persistence only if not already granted
              return navigator.storage.persist();
            }
          }).then(newlyGranted => {
            if (newlyGranted !== undefined) {
              console.info('Storage persistence is ' + (newlyGranted ? 'granted' : 'denied'));
              persistenceValue = newlyGranted;
            }
          }).catch(error => {
            console.error('Error managing storage persistence:', error);
          });
        }
        
        // Return 1 for compatibility with code expecting StorageType.persistent
        return 1;
      }
    });
    
    console.info('Applied compatibility fix for StorageType.persistent');
  } catch (error) {
    console.error('Failed to apply StorageType.persistent fix:', error);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
